import styled, { css } from "styled-components";
import { TertiaryButton } from "@ddm-design-system/button";

export const EditButton = styled(TertiaryButton)(
  ({ theme }) => css`
    color: ${theme.colors.grey.grey100};
  `
);
